<script>
import Mixin from "@utilities/mixin";
import ReportTableBox from "@components/reports/EOD/ReportTableBox.vue";

export default {
  name: "RevenueTable",
  components: {ReportTableBox},
  mixins: [Mixin],
  props: {
    editing: Boolean,
    dataTable: Array,
    total: Number
  },
  data() {
    return {
      localDataTable: this.dataTable
    }
  },
  watch: {
    localDataTable: {
      handler() {
        this.$emit("updateDataTable", this.localDataTable);
      },
      deep: true
    }
  },
  methods: {
    cap(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
  }
}
</script>

<template>
  <ReportTableBox title="Revenue">
    <DataTable :value="dataTable" size="small" class="custom-table w-full rounded-b-lg">
      <Column field="type">
        <template #header>
          <span class="md:pl-4 pl-0 font-semibold">Type</span>
        </template>
        <template #body="slotProps">
          <span class="md:pl-4 p-0">{{ cap(slotProps.data.label) }}</span>
        </template>
      </Column>
      <Column field="amount">
        <template #header>
          <div class="flex justify-center items-center w-full">
            <span class="text-center font-semibold">Amt</span>
          </div>
        </template>
        <template #body="{data, field}">
          <div class="flex justify-center items-center w-full">
            <InputNumber :min="0" :minFractionDigits="2" v-if="editing" class="sleek-input" v-model="data[field]"
                         autofocus fluid/>
            <p v-else class="m-0">
              {{ data[field] }}
            </p>
          </div>
        </template>
      </Column>
      <Column field="total">
        <template #header>
          <div class="flex justify-end items-center w-full md:pr-4 pr-0">
            <span class="text-end font-semibold">Value</span>
          </div>
        </template>
        <template #body="slotProps">
          <div class="flex justify-end items-center w-full md:pr-4 pr-0">
            <span>{{ formatUSD(parseFloat(slotProps.data.amount) * parseFloat(slotProps.data.price)) ?? 0 }}</span>
          </div>
        </template>
      </Column>
      <ColumnGroup type="footer">
        <Row>
          <Column :colspan="2">
            <template #footer>
              <span class="font-semibold md:pl-4 pl-0">Total</span>
            </template>
          </Column>
          <Column>
            <template #footer>
              <div class="flex justify-end items-center w-full md:pr-4 pr-0">
                <span class="font-semibold text-end">{{ formatUSD(total) }}</span>
              </div>
            </template>
          </Column>
        </Row>
      </ColumnGroup>
    </DataTable>
  </ReportTableBox>
</template>

<style scoped>

</style>